export interface IStaffImport {
  honorificTitleId: number;
  personalEmail: string;
  firstName: string;
  lastName: string;
  merchantGroupId: number;
  merchantId: number;
  costCentreId: number;
  genderId: number;
  departmentId: number;
  jobTitleId: number;
  startDate: Date;
  roleComponentId: number;
  mealCardTypeId: number;
  chatChannelArray: string[];
}
